import styled from 'styled-components';

export const Flex = styled.div<{ gap?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${(props) => props.gap};
`;
